/**
 * customerWaiversApi — AISC §1.7.0 Phase 4 customer waiver client.
 */

import ApiCall from "./apicall";

export const WAIVER_STATUSES = ["REQUESTED", "RECEIVED", "ACTIVE", "REVOKED"];
export const WAIVER_SCOPES = ["DRAWING_APPROVAL", "SHOP_DRAWING_APPROVAL", "OTHER"];

export async function listWaivers(filters = {}) {
  const params = {};
  if (filters.job_id) params.job_id = filters.job_id;
  if (filters.status) params.status = filters.status;
  if (filters.limit) params.limit = filters.limit;
  const res = await ApiCall.get("/customer-waiver", { params });
  return res.data;
}
export async function getWaiver(id) { const res = await ApiCall.get(`/customer-waiver/${id}`); return res.data; }
export async function createWaiver(payload) { const res = await ApiCall.post("/customer-waiver", payload); return res.data; }
export async function updateWaiver(id, patch) { const res = await ApiCall.patch(`/customer-waiver/${id}`, patch); return res.data; }
export async function receiveWaiver(id, payload) { const res = await ApiCall.post(`/customer-waiver/${id}/receive`, payload); return res.data; }
export async function activateWaiver(id) { const res = await ApiCall.post(`/customer-waiver/${id}/activate`); return res.data; }
export async function revokeWaiver(id, revoke_reason) { const res = await ApiCall.post(`/customer-waiver/${id}/revoke`, { revoke_reason }); return res.data; }

export function allowedWaiverTransitions(status) {
  const T = { REQUESTED: ["RECEIVED", "REVOKED"], RECEIVED: ["ACTIVE", "REVOKED"], ACTIVE: ["REVOKED"], REVOKED: [] };
  return T[String(status || "").toUpperCase()] || [];
}
